<template>
  <div class="tituloPrincipal">
    <div class="cont-titulo">
      <img :src="imagen" alt="" v-if="imagen" />

      <div class="titulo" :class="{ vertical: vertical }">
        <h2 class="h1-hero">{{ titulo }}</h2>
        <p v-if="subtitulo" class="p-base">{{ subtitulo }}</p>
      </div>
    </div>

    <BtnCComponent
      :texto="textoBoton"
      @click="dialog = true"
      v-if="textoBoton"
    />
    <router-link :to="link" v-if="link">
      <BtnCComponent
        :texto="width > 770 ? '+ Nueva Representación' : '+ Nueva'"
      />
    </router-link>
  </div>
  <ModalContenedorComponent
    v-if="dialog"
    :cerrar="closeDialog"
    mostrarClose="true"
    mobilePosition="bottom"
    fondo="var(--bg-popup)"
  >
    <ModalAgregarComponent
      :titulo="titulo.slice(0, -1)"
      @cerrar="closeDialog"
    />
  </ModalContenedorComponent>
</template>
<script>
import BtnCComponent from "../Buttons/BtnCComponent.vue";
import ModalContenedorComponent from "../Modales/ModalContenedorComponent.vue";
import ModalAgregarComponent from "../Modales/ModalAgregarComponent.vue";
import TurnosImg from "./../../assets/images/LuqueTurnos.svg";
import DatosImg from "./../../assets/images/LuqueDatos.svg";
import TramitesImg from "./../../assets/images/LuqueTramites.svg";
import DocumentosImg from "./../../assets/images/LuqueDocumentos.svg";
import NotificacionesImg from "./../../assets/images/LuqueNotificaciones.svg";
import RepresentacionesImg from "./../../assets/images/LuqueRepresentaciones.svg";
export default {
  name: "TituloComponent",
  data() {
    return {
      dialog: false,
      width: window.innerWidth,

      img: {
        Turnos: TurnosImg,
        Notificaciones: NotificacionesImg,
        Trámites: TramitesImg,
        Documentos: DocumentosImg,
        Representaciones: RepresentacionesImg,
        Datos: DatosImg,
      },
      imagen: null,
    };
  },
  created() {
    // console.log(this.$store.state.tramiteStore);
    if (this.titulo.includes(" ")) {
      let asd = this.titulo.split(" ");
      this.imagen = this.img[asd[1]];
    } else {
      this.imagen = this.img[this.titulo];
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.width = window.innerWidth;
    },
    closeDialog() {
      this.dialog = false;
    },
  },
  props: {
    subtitulo: {
      type: String,
    },
    titulo: String,
    textoBoton: String,
    link: String,
    vertical: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BtnCComponent,
    ModalContenedorComponent,
    ModalAgregarComponent,
  },
};
</script>
<style scoped>
h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0px;
  color: var(--text-primary);
}

.tituloPrincipal {
  width: var(--width);
  color: #fff;
  display: flex;
  flex-direction: row;
  margin: auto;
  justify-content: space-between;
  text-align: left;
  margin-top: var(--margin60);
}
.cont-titulo {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  height: 6.678vh;
}
.cont-titulo img {
  height: 5.509vh;
  width: 2.416vw;
}
.titulo {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.titulo.vertical {
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
@media (max-width: 990px) {
  .tituloPrincipal {
    margin: auto;
    width: 100%;
    margin-top: var(--gap30);
    margin-bottom: var(--gap30);
    text-align: left;
    padding: 0px;
  }
  img {
    height: var(--gap20);
    width: var(--gapHM25);
  }

  .cont-titulo img {
    height: var(--gap20);
    width: unset;
  }
}
@media (max-width: 770px) {
  .tituloPrincipal {
    margin: auto;
    width: 100%;
    margin-top: var(--gap30);
    margin-bottom: var(--gap30);
    text-align: left;
    padding: 0px;
  }
  img {
    height: var(--gap20);
    width: var(--gapHM25);
  }

  .cont-titulo img {
    height: var(--gap20);
    width: unset;
  }
}

@media (max-width: 460px) {
  .tituloPrincipal {
    width: 100%;
    margin-top: 30px;
    margin-bottom: 30px;

    align-items: center;
  }
  .cont-titulo img {
    height: 22px;
    width: 22px;
  }
  .cont-titulo {
    max-height: 30px;
    height: unset;
  }
}
</style>
